<script setup lang="ts">
const props = withDefaults(defineProps<{
  title: string;
  description?: string;
  to?: string;
}>(), {
  description: "",
  to: "",
});
</script>

<template>
  <NuxtLink
    v-if="props.to"
    :to="props.to"
    class="block rounded-[22px] border border-slate-200 bg-slate-50 p-4 transition hover:-translate-y-0.5 hover:border-amber-300 hover:bg-white hover:shadow-[0_18px_40px_-26px_rgba(245,158,11,0.45)] dark:border-slate-700 dark:bg-slate-950/40 dark:hover:border-amber-700 dark:hover:bg-slate-900"
  >
    <h3 class="text-lg font-semibold text-slate-900 dark:text-white">{{ title }}</h3>
    <p v-if="description" class="mt-3 text-sm leading-6 text-slate-600 dark:text-slate-300">
      {{ description }}
    </p>
    <p class="mt-4 text-sm font-semibold text-amber-700 dark:text-amber-300">Open page -></p>
  </NuxtLink>
  <article
    v-else
    class="rounded-[22px] border border-slate-200 bg-slate-50 p-4 transition dark:border-slate-700 dark:bg-slate-950/40"
  >
    <h3 class="text-lg font-semibold text-slate-900 dark:text-white">{{ title }}</h3>
    <p v-if="description" class="mt-3 text-sm leading-6 text-slate-600 dark:text-slate-300">
      {{ description }}
    </p>
  </article>
</template>
